export default __webpack_public_path__ + "static/media/ic_sms.cede062c.svg";